const {
  append,
  assoc,
  compose,
  concat,
  dissoc,
  equals,
  findIndex,
  flip,
  has,
  identical,
  lensProp,
  merge,
  prepend,
  prop,
  reject,
  update,
} = require('ramda')
const { hasId, rejectByProps } = require('@mediatool/mt-utils/import')
const { uniqBy, propEq } = require('yafu')

const self = {}

self.updateBy = function (propName) {
  return function (list, entity) {
    const entityVal = prop(propName, entity)
    const index = findIndex(propEq(propName, entityVal), list)
    return index === -1
      ? append(entity, list)
      : update(index, entity, list)
  }
}

self.updateById = self.updateBy('_id')

self.addAll = (list1, list2) => uniqBy(prop('_id'), concat(list2, list1))

self.add = flip(append)

self.addUnique = function (list, item) {
  const index = findIndex(hasId(item._id), list)
  return index === -1 ? append(item, list) : update(index, item, list)
}

self.removeById = function (list, id) {
  return reject(hasId(id), list)
}

self.removeIdentical = function (list, item) {
  return reject(identical(item), list)
}

self.removeAllById = function (list, removeIds) {
  return rejectByProps('_id', removeIds, list)
}

self.removeByProp = function (p) {
  return (list, val) => reject(propEq(p, val), list)
}

self.prepend = flip(prepend)

self.appendTo = function (propName) {
  const lens = lensProp(propName)
  return function (entity, val) {
    return has(propName, entity)
      ? lens.map(append(val), entity)
      : assoc(propName, [ val ], entity)
  }
}

self.removeFrom = function (propName) {
  const lens = lensProp(propName)
  return function (entity, val) {
    return has(propName, entity)
      ? lens.map(reject(equals(val)), entity)
      : entity
  }
}

self.merge = merge

self.removeProp = flip(dissoc)
self.setProp = compose(flip, assoc)

module.exports = self
